module.exports = __webpack_public_path__ + "img/zd1.f0bf93f3.png";